import { TransformOrigin } from 'types'

enum CropScaler {
    BottomLeft = 'bottom-left',
    BottomRight = 'bottom-right',
    TopLeft = 'top-left',
    TopRight = 'top-right',
}

namespace CropScaler {
    export function all(): CropScaler[] {
        return [CropScaler.TopLeft, CropScaler.TopRight, CropScaler.BottomRight, CropScaler.BottomLeft]
    }

    export function css(scaler: CropScaler, offset: number = 0): string {
        switch (scaler) {
            case CropScaler.BottomLeft:
                return `bottom: ${offset}px; left: ${offset}px;`
            case CropScaler.BottomRight:
                return `bottom: ${offset}px; right: ${offset}px;`
            case CropScaler.TopLeft:
                return `left: ${offset}px; top: ${offset}px;`
            case CropScaler.TopRight:
                return `right: ${offset}px; top: ${offset}px;`
        }
    }

    export function cursor(scaler: CropScaler): string {
        switch (scaler) {
            case CropScaler.BottomLeft:
                return 'sw-resize'
            case CropScaler.BottomRight:
                return 'se-resize'
            case CropScaler.TopLeft:
                return 'nw-resize'
            case CropScaler.TopRight:
                return 'ne-resize'
        }
    }

    export function rotation(scaler: CropScaler): number {
        switch (scaler) {
            case CropScaler.BottomLeft:
                return 90
            case CropScaler.BottomRight:
                return 0
            case CropScaler.TopLeft:
                return 180
            case CropScaler.TopRight:
                return 270
        }
    }

    export function transformOrigin(scaler: CropScaler): TransformOrigin {
        switch (scaler) {
            case CropScaler.BottomLeft:
                return 'top-right'
            case CropScaler.BottomRight:
                return 'top-left'
            case CropScaler.TopLeft:
                return 'bottom-right'
            case CropScaler.TopRight:
                return 'bottom-left'
        }
    }
}

export default CropScaler
